import { AfterViewInit, ChangeDetectorRef, Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { _HttpClient } from '@delon/theme';
import { NzSelectComponent } from 'ng-zorro-antd/select';
import { AccountCodeComponent } from 'src/app/components/modal/account-code/account-code-modal.component';

import { SelectInstantBaseComponent } from '../../selectInstant-base';
import { SelectInstantBaseNewComponent } from '../../selectInstant-base-new';

@Component({
  selector: 'app-ccac-select',
  templateUrl: './ccac-select.component.html',
  styleUrls: ['./ccac-select.component.less'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SupplierControlAccountSelectComponent),
      multi: true
    }
  ]
})
export class SupplierControlAccountSelectComponent
  extends SelectInstantBaseNewComponent
  implements OnInit, AfterViewInit
{
  @ViewChild('selector') nzSelectComponent!: NzSelectComponent;
  @ViewChild('codeModal', { static: true })
  accCodeModalComponent!: AccountCodeComponent;

  NotShowInReport: boolean = false;

  constructor(
    http: _HttpClient,
    cdr: ChangeDetectorRef,
    router: Router,
    private reuseTabService: ReuseTabService
  ) {
    super(http, cdr, router);
    this.valueField = '';
  }

  ngOnInit(): void {
    this.checkAddNewOptionInReportAccess();
    
    // Listen to search form changes to store instant data
    this.searchForm.controls.keyword.valueChanges.subscribe(value => {
      if (value) {
        this.storedInstantData = value.trim();
      }
    });

    // Ensure the correct item is active whenever the list updates while open
    this.onListFilled.subscribe(() => {
      if ((this.nzSelectComponent as any)?.nzOpen) {
        this.ensureFirstItemActivatedAndFocused();
      }
    });
  }

  ngAfterViewInit(): void {
    // Additional initialization if needed
    // This method is required by AfterViewInit interface
    if (this.nzSelectComponent) {
      // Component is ready for additional initialization
    }
  }

  getUrl(searchValue: string): string {
    let url = `api/accountcodes/search?$top=50&$skip=0&$filter=IsActive eq true and SpecialCode eq 'CCAC'`;
    if (searchValue && searchValue.trim()) {
      url = `${url}&keyword=${encodeURIComponent(searchValue.trim())}`;
    } else {
      url = `${url}&$orderby=code asc`;
    }
    return url;
  }

  // set the location want to navigate
  jump(): string {
    return '/gl/coa';
  }

  // set the param
  queryParam(): String {
    return 'AccountCode';
  }

  // Override search method to store instant data
  override search(value: string, maxLength: number = 10): void {
    // Store the instant data before calling parent method
    this.storedInstantData = value.trim();
    super.search(value, maxLength);
  }

  override valueChanged(val: any): void {
    if (val === 'addNew') {
      // Handle add new button click
      return;
    } else {
      super.valueChanged(val);
    }
  }

  onSubmit(account: any) {
    if (account) {
      // Check if the special code matches the expected initSpecialCode
      const expectedSpecialCode = 'CCAC';
      const actualSpecialCode = account.specialCode;
      const initSpecialCode = account.initSpecialCode;
      
      
      // Only proceed if the special code matches the expected one AND initSpecialCode matches
      if (actualSpecialCode == expectedSpecialCode) {
        // Create the account object in the expected format
        const accountObj = {
          id: account.id,
          code: account.code,
          name: account.name,
          specialCode: account.specialCode,
          isActive: account.isActive
        };

        // Add the new account to the list and select it
        this.list.unshift(accountObj);

        // Set the account object in the form control to trigger value changes
        this.value = accountObj.id;
        this.selected = accountObj.id;

        // Set the account object directly in the form control
        this.onChange(accountObj);
        this.writeValue(accountObj);

        // Clear stored instant data after successful creation
        this.clearStoredInstantData();
        
        // Force change detection
        this.cdr.detectChanges();
      } else {
        // Special code doesn't match, don't add to list or select
        // Clear stored instant data
        this.clearStoredInstantData();
      }
    }
    else{
              this.clearStoredInstantData();
    }
  }

  checkAddNewOptionInReportAccess(): boolean {
    let curUrl = this.reuseTabService.curUrl.toLowerCase();

    if (curUrl.includes('report')) {
      this.NotShowInReport = true;
    } else {
      this.NotShowInReport = false;
    }

    return this.NotShowInReport;
  }

 
  override addNew() {
    // Close the dropdown first
    if (this.selector) {
      this.selector.setOpenState(false);
    }
    
    // Open the modal directly without calling super.addNew() to prevent navigation
    this.http.get(`api/accounttypes/typecode/BCL`).subscribe(res => {
      if (res)
        this.accCodeModalComponent.new({
          parentId: res[0].id,
          specialCode: 'CCAC',
          isActive: true,
          name: this.storedInstantData || this.instantData
        });
    });

    setTimeout(() => {
      this.clearSelection();
    }, 50);
  }
}
